/**
 * @Author : ZhuYongFang
 * @Date : 2019/6/10
 * @Version : 1.0
 * @Content : 任务数据管理 --- 空间管理
 */
// import $http from '@/utils/fetch'
import $http from '@/utils/requestAxios'

// 任务数据列表
export const apiTaskData = {
  // 列表
  list (query, page = 1, size = 10) {
    return $http.get('/queues', { ...query, page, size })
  },
  // 新增
  add (query) {
    return $http.post('/queues', query)
  },
  // 修改
  modify (query) {
    return $http.put('/queues', query)
  },
  // 删除
  del (query) {
    return $http.delete('/queues', query)
  },
  // 清空记录
  clear (query) {
    return $http.delete('/queues/items', query)
  }
}

// 查看数据
export const apiViewData = {
  // 获取表头数据
  getThFields (query, page = 1, size = 1) {
    return $http.get('/esview', { ...query, page, size })
  },
  // 新增表头
  addTh (query) {
    return $http.post('/esview', query)
  },
  // 修改表头
  modTh (query) {
    return $http.put('/esview', query)
  },
  // 空间子项数据
  getSpaceData (query, page = 1, size = 1) {
    return $http.get('/queues/items', { ...query, page, size })
  },
  // 删除
  del (id) {
    return $http.delete(`/queues/items/${id}`)
  },
  // 重做
  reStart (query) {
    return $http.$put('/queues/items/retry', query)
  },
  // 查看访问记录
  viewLogs (query, page = 1, size = 1) {
    return $http.get('/queues/items/visit', { ...query, page, size })
  },
  // 清空访问记录
  clear (query) {
    return $http.delete('/queues/items/his', query)
  }
}
